const getMainNavData = (element, colPreviousElement) => {
    const subMenu = $(element).closest('ul');
    if (subMenu.hasClass('header__subnav')) {
        return {
            col:
                $('.header__nav > ul > li > a, .header__nav > ul > li > div').index(
                    subMenu.siblings('a,div')[0],
                ) + colPreviousElement,
            row: subMenu.find('a').index(element) + 1,
        };
    } else {
        return {
            col:
                $('.header__nav > ul > li > a, .header__nav > ul > li > div').index(element) +
                colPreviousElement,
            row: 0,
        };
    }
};

const trackAction = (trackingEventString = '', trackingObject = {}) => {
    trackingObject = Object.assign(trackingObject, initializeEndcardTrackingData);
    // 5s will be the timeout / 5 times it will try to check for "om" value , if it is still undefined -> Exists loop and logs error in console.
    const callTrackAction = () => {
        if (typeof om != 'undefined') {
            om.trackAction(trackingEventString, trackingObject);
        }
    };

    // Call trackAction immediately if possible, otherwise wait for om object
    if (typeof om !== 'undefined') {
        callTrackAction();
    } else {
        let tryCount = 0;
        const checkOm = setInterval(() => {
            tryCount++;
            if (typeof om !== 'undefined') {
                callTrackAction();
                clearInterval(checkOm);
            }
            if (tryCount >= 5) {
                console.error('om is not loaded yet!');
                clearInterval(checkOm);
            }
        }, 1000);
    }
};

const getAccountNavData = (element, colPreviousElement) => {
    if (CBS.Registry.user_auth === true) {
        const subMenu = $(element).closest('ul');
        return {
            row: subMenu.find('a').index(element) + 1,
            col: $('.header__account > li > ul > li > a').index(element) + colPreviousElement,
        };
    } else {
        return {
            col: $('.header__account > li > a').index(element) + colPreviousElement,
            row: 0,
        };
    }
};

const getTrackingData = (element) => {
    let trackingData = {
        row: 0,
        col: 0,
    };

    // row & col values not applicable for the upgrade nav button
    const isAAUpsellCta = $(element).parents('li').hasClass(AAUpsellNavCta) ?? false;
    if (isAAUpsellCta) return trackingData;

    let colPreviousElement = $('.header__nav .siteLogo').length;

    if (
        $('.navigation.header__nav--items')[0] &&
        $.contains($('.navigation.header__nav--items')[0], element)
    ) {
        trackingData = getMainNavData(element, colPreviousElement);
    }

    colPreviousElement += $('.header__nav > ul > li > a, .header__nav > ul > li > div').length;

    if ($.contains($('.header__account')[0], element)) {
        trackingData = getAccountNavData(element, colPreviousElement);
    }

    return trackingData;
};

/**
 * Fires a tracking event for a given menu element, handling special cases for live TV and menu overrides.
 *
 * @param {HTMLElement} element - The DOM element that triggered the tracking event.
 * @param {Object} [trackMenuOverrideValues] - Optional object containing values to override default menu tracking data
 *
 * @returns {void}
 */
const fireTrackingEvent = (element, trackMenuOverrideValues) => {
    const { row, col } = getTrackingData(element);
    const isAAUpsellCta = $(element).parents('li').hasClass(AAUpsellNavCta) ?? false;
    const isSearch =
        $(element).parent()[0] === $(element).parents('ul').find('li').last()[0] &&
        $(element).hasClass('search');
    const title =
        !isAAUpsellCta && row === 0 && (col === 0 || isSearch)
            ? $(element)?.attr('aa-link')?.split('||')[1]
            : $.trim($(element).text());

    let key = CBS.Registry.brand.name === 'PPLUS' ? 'PPlusSubscriberBadge' : 'TVELockedBadge';
    let lockFlag = 0;

    if (!CBS.Registry.user.id && CBS.Registry.brand.name === 'PPLUS') {
        lockFlag = 1;
    }

    if (element.href.indexOf('live-tv') > -1) {
        let liveTvChannel = title;
        if (element.href.indexOf('stream/cbsn') > 1) {
            liveTvChannel = 'CBSN Live Stream';
        } else if (element.href.indexOf('stream') > 1) {
            liveTvChannel = 'Live Local TV';
        }
        var trackLiveChannelSelect = {
            liveTvChannel: liveTvChannel,
            [key]: lockFlag.toString(),
            menuItemLabel: title,
            posRowNum: row.toString(),
            posColNum: col.toString(),
            TVELockedBadge: lockFlag,
            menuOrientation: 'header',
            showGenre: CBS.Registry.region.property != 'US' ? 'News' : '',
        };
        if (
            !localStorage.getItem('nextGenMenuClicked') ||
            localStorage.getItem('nextGenMenuClicked') !== 1
        ) {
            trackAction('trackMenu', trackLiveChannelSelect);
            window.localStorage.setItem(
                'metadata-video-tracking',
                JSON.stringify(trackLiveChannelSelect),
            );
        } else {
            localStorage.removeItem('nextGenMenuClicked');
        }
    } else {
        const trackMenuValues = {
            ctaText: element.innerText.trim().toLowerCase(),
            posRowNum: row.toString(),
            posColNum: col.toString(),
            menuOrientation: 'header',
        };

        if (trackMenuOverrideValues && typeof trackMenuOverrideValues === 'object') {
            Object.assign(trackMenuValues, trackMenuOverrideValues);
        }

        trackAction('trackMenu', trackMenuValues);
    }
};

const trackView = (params) => {
    if (typeof om == 'undefined') {
        setTimeout(() => {
            if (typeof om != 'undefined') {
                om.trackView(params);
            }
        }, 2000);
    } else {
        om.trackView(params);
    }
};

const isNavMenuItem = (element) => {
    if ($(element).hasClass('filter')) {
        return false;
    }
    return true;
};

const omReady = () => {
    return new Promise((resolve, reject) => {
        try {
            CBS.Promises.Tracking.onLoad(() => {
                resolve();
            });
        } catch (e) {
            reject();
        }
    });
};

const initializeEndcardTrackingData = {
    endCardContentList: '',
    endCardContentPosition: '',
    endCardCountdownTime: '',
    endCardSource: '',
    endCardType: '',
    endCardContentListType: '',
    endCardContentListCount: '',
    endCardSourceType: '',
    contPlayState: '',
    endCardRecommendedContentIdList: '',
    endCardSourceContentId: '',
    endCardRecommendationSource: '',
    endCardTriggerType: '',
    endCardTimerTotal: '',
    endCardContentSelection: '',
};

const AAUpsellNavCta = 'all-access-upsell-button';

export {
    isNavMenuItem,
    fireTrackingEvent,
    omReady,
    trackAction,
    trackView,
    initializeEndcardTrackingData,
};
